import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Button,
  Col,
  Empty,
  Row,
  Select,
  Table,
  Form,
  Alert,
  Modal,
  Tabs,
  Divider,
  Result,
  Spin,
  message,
  Tooltip,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { LogoContainer } from "../../../../Login/Login.styles";
import { useFetchConstant } from "apis/constant";
import {
  useGetAdviseeProposalReporting,
  useGetAdviseeProposals,
} from "apis/advisee";
import {
  constructShortenedFinancialNumber,
  getLabelOfConstant,
  guard,
} from "utils/general";
import { getReportingData } from "utils/reporting";
import { buildPNRProposalsUri } from "utils/routes";
import Title from "components/Title/Title";

import { TypeAnimation } from "react-type-animation";
import messagingSocket from "apis/socket/messaging.socket";
import PromptForm from "./components/promptForm";
import ChatBoxComponent from "./components/chatbox";
import SolutionsForm from "./components/SolutionsForm";
import ProposalsList from "./components/ProposalsList";
import RiskRatios from "./components/RiskRatios";
import { getConversationHistory } from "../../../../../apis/externalAPI/aigc";
import socketConnector from "apis/socket/socket";
import { getGptSolutions, saveProposals } from "apis/gpt";
import {
  getSolutionsByAdviseeId,
  createSolution,
  getSolutionById,
  convertToSolution,
  deleteSolution,
} from "apis/aiSolutions";
import { defaultGptProjectId } from "utils/constants";
import { getUserAuthObj } from "utils/auth";
import { getJWTToken } from "apis/apiHelper";

const MemoizedChatBoxComponent = React.memo(ChatBoxComponent);

const GptSolutions = (props) => {
  const history = useHistory();
  const jwtToken = getJWTToken();
  const { id: adviseeId } = useParams();

  /////////////////////////

  const scrollRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [tabLoding, setTabLoading] = useState(false);
  const [triggerSendMsg, setTriggerSendMsg] = useState(false);

  const [connectionError, setConnectionError] = useState(true);
  const [connectionSuccessStatus, setConnectionSuccessStatus] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [input, setInput] = useState("");
  const [regenerateInput, setRegenerateInput] = useState("");

  const [solutionStep, setSolutionStep] = useState(0);
  const [gptSolutionsData, setGptSolutionsData] = useState({});
  const [proposalsData, setProposalsData] = useState([
    // {
    //   display: ["deathBenefit", "tpdBenefit", "tpdWaiver"],
    //   _id: "66c9aace8560dea58912e733",
    //   description: "Life Protection",
    //   theme: {
    //     bgColor: "#E93324",
    //   },
    //   remarks: "",
    //   status: "active",
    //   setId: "3LVTRXH2Q",
    //   name: "Option 1",
    //   premiumSurrendered: 0,
    //   policyData: {
    //     deathWaiverPremium: 280.1333,
    //     deathWaiverPremiumForSelf: 280.1333,
    //     ciWaiverPremium: 0,
    //     tpdWaiverPremium: 20.8333,
    //     monthlyPremium: 280.1333,
    //     yearlyPremium: 3361.6,
    //     medicalCardYearlyLimitAmt: 0,
    //     medicalCardLifetimeLimitAmt: 0,
    //     medicalCardRoomAndBoardAmt: 0,
    //     deathBenefit: 310000,
    //     tpdBenefit: 310000,
    //     oldAgeDisabilityBenefit: 300000,
    //     tpdWaiver: true,
    //     permanentDisabilityMonthlyIncome: 0,
    //     personalAccidentBenefit: 0,
    //     ciBenefit: 0,
    //     totalEarlyCIBenefit: 0,
    //     accidentalDeathBenefit: 0,
    //     accidentalTpdBenefit: 0,
    //     extraCoverage: [],
    //   },
    //   addedPolicyData: {
    //     deathWaiverPremium: 20.8333,
    //     deathWaiverPremiumForSelf: 20.8333,
    //     ciWaiverPremium: 0,
    //     tpdWaiverPremium: 20.8333,
    //     monthlyPremium: 20.8333,
    //     yearlyPremium: 250,
    //     medicalCardYearlyLimitAmt: 0,
    //     medicalCardLifetimeLimitAmt: 0,
    //     medicalCardRoomAndBoardAmt: 0,
    //     deathBenefit: 300000,
    //     tpdBenefit: 300000,
    //     oldAgeDisabilityBenefit: 300000,
    //     tpdWaiver: true,
    //     permanentDisabilityMonthlyIncome: 0,
    //     personalAccidentBenefit: 0,
    //     ciBenefit: 0,
    //     totalEarlyCIBenefit: 0,
    //     accidentalDeathBenefit: 0,
    //     accidentalTpdBenefit: 0,
    //     extraCoverage: [],
    //   },
    // },
    // {
    //   display: ["deathBenefit", "tpdBenefit", "tpdWaiver"],
    //   _id: "66c9ce978560dea58912e790",
    //   description: "Life Protection",
    //   theme: {
    //     bgColor: "#BEDDE6",
    //   },
    //   remarks: "",
    //   status: "active",
    //   setId: "3LVTRXH2Q",
    //   name: "Option 2",
    //   premiumSurrendered: 0,
    //   policyData: {
    //     deathWaiverPremium: 296.8,
    //     deathWaiverPremiumForSelf: 296.8,
    //     ciWaiverPremium: 0,
    //     tpdWaiverPremium: 37.5,
    //     monthlyPremium: 296.8,
    //     yearlyPremium: 3561.6,
    //     medicalCardYearlyLimitAmt: 0,
    //     medicalCardLifetimeLimitAmt: 0,
    //     medicalCardRoomAndBoardAmt: 0,
    //     deathBenefit: 510000,
    //     tpdBenefit: 510000,
    //     oldAgeDisabilityBenefit: 500000,
    //     tpdWaiver: true,
    //     permanentDisabilityMonthlyIncome: 0,
    //     personalAccidentBenefit: 0,
    //     ciBenefit: 0,
    //     totalEarlyCIBenefit: 0,
    //     accidentalDeathBenefit: 0,
    //     accidentalTpdBenefit: 0,
    //     extraCoverage: [],
    //   },
    //   addedPolicyData: {
    //     deathWaiverPremium: 37.5,
    //     deathWaiverPremiumForSelf: 37.5,
    //     ciWaiverPremium: 0,
    //     tpdWaiverPremium: 37.5,
    //     monthlyPremium: 37.5,
    //     yearlyPremium: 450,
    //     medicalCardYearlyLimitAmt: 0,
    //     medicalCardLifetimeLimitAmt: 0,
    //     medicalCardRoomAndBoardAmt: 0,
    //     deathBenefit: 500000,
    //     tpdBenefit: 500000,
    //     oldAgeDisabilityBenefit: 500000,
    //     tpdWaiver: true,
    //     permanentDisabilityMonthlyIncome: 0,
    //     personalAccidentBenefit: 0,
    //     ciBenefit: 0,
    //     totalEarlyCIBenefit: 0,
    //     accidentalDeathBenefit: 0,
    //     accidentalTpdBenefit: 0,
    //     extraCoverage: [],
    //   },
    // },
    // {
    //   display: [
    //     "deathBenefit",
    //     "tpdBenefit",
    //     "oldAgeDisabilityBenefit",
    //     "ciWaiver",
    //     "tpdWaiver",
    //   ],
    //   _id: "66c9a9b08560dea58912e5f0",
    //   name: "Option 3",
    //   description: "",
    //   theme: {
    //     bgColor: "#D7FED0",
    //   },
    //   remarks: "",
    //   status: "active",
    //   setId: "3LVTRXH2Q",
    //   premiumSurrendered: 0,
    //   policyData: {
    //     deathWaiverPremium: 259.3,
    //     deathWaiverPremiumForSelf: 259.3,
    //     ciWaiverPremium: 0,
    //     tpdWaiverPremium: 0,
    //     monthlyPremium: 259.3,
    //     yearlyPremium: 3111.6,
    //     medicalCardYearlyLimitAmt: 0,
    //     medicalCardLifetimeLimitAmt: 0,
    //     medicalCardRoomAndBoardAmt: 0,
    //     deathBenefit: 10000,
    //     tpdBenefit: 10000,
    //     oldAgeDisabilityBenefit: 0,
    //     permanentDisabilityMonthlyIncome: 0,
    //     personalAccidentBenefit: 0,
    //     ciBenefit: 0,
    //     totalEarlyCIBenefit: 0,
    //     accidentalDeathBenefit: 0,
    //     accidentalTpdBenefit: 0,
    //     extraCoverage: [],
    //   },
    //   addedPolicyData: {
    //     deathBenefit: 0,
    //     tpdBenefit: 0,
    //     oldAgeDisabilityBenefit: 0,
    //     permanentDisabilityMonthlyIncome: 0,
    //     personalAccidentBenefit: 0,
    //     ciBenefit: 0,
    //     totalEarlyCIBenefit: 0,
    //     accidentalDeathBenefit: 0,
    //     accidentalTpdBenefit: 0,
    //     monthlyPremium: 0,
    //     yearlyPremium: 0,
    //   },
    // },
  ]);
  const [riskRatiosData, setRiskRatiosData] = useState([
    // {
    //   name: "Proposal 1",
    //   _id: "1",
    //   naturalDeathCoverageData: [
    //     {
    //       label: "Cover Ratio",
    //       desc: "Based on current age",
    //       range: "27.6 - 31",
    //       value: "0.70",
    //       isInRange: false,
    //       optimisedValue: "24.12",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Death to Total Funding (DTF)",
    //       desc:
    //         "Months of coverage for family after deducting all mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Death to Basic Funding (DBF)",
    //       desc:
    //         "Months of coverage for family after deducting home mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Death to Unsettled Funding (DUF)",
    //       desc:
    //         "Months of coverage for family after deducting immediate death expenses but ignoring all mortgages",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Total Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering all properties mortgage being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Basic Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering home mortgage only being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   accidentalDeathCoverageData: [
    //     {
    //       label: "Accidental Death to Total Funding (DTF)",
    //       desc:
    //         "Months of coverage for family after deducting all mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Death to Basic Funding (DBF)",
    //       desc:
    //         "Months of coverage for family after deducting home mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Death to Unsettled Funding (DUF)",
    //       desc:
    //         "Months of coverage for family after deducting immediate death expenses but ignoring all mortgages",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Total Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering all properties mortgage being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Basic Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering home mortgage only being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   medicalBenefitCoverageData: [
    //     {
    //       label: "Critical Illness (CI) to Monthly Expenses",
    //       desc: "Critical Illness to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "CI-RRF to Monthly Expenses",
    //       desc:
    //         "Critical Illness after reserved for Recovery & Recuperation Funds to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Early CI to Monthly Expenses",
    //       desc: "Critical Illness to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Early CI-RRF to Monthly Expenses",
    //       desc:
    //         "Critical Illness after reserved for Recovery & Recuperation Funds to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Basic CI-IFS",
    //       desc: "Critical Illness Funding Solution Living Expenses Only",
    //       range: "> 100.00%",
    //       value: "0.00%",
    //       isInRange: false,
    //       optimisedValue: "0.00%",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Complete CI-IFS",
    //       desc:
    //         "Critical Illness Funding Solution Living Expenses and Recovery + Recuperation Funds",
    //       range: "> 100.00%",
    //       value: "0.00%",
    //       isInRange: false,
    //       optimisedValue: "0.00%",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Medical Health Insurance (MHI) Funding 0.00",
    //       desc:
    //         "Medical Health Insurance to cover major illness needed to cure",
    //       range: "> 2 times",
    //       value: "10.00",
    //       isInRange: true,
    //       optimisedValue: "10.00",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label:
    //         "Medical Health Insurance (MHI) and Critical Illness (CI) Funding 0.00",
    //       desc:
    //         "Medical Health Insurance and Critical Illness to cover major illness needed to cure",
    //       range: "> 2 times",
    //       value: "10.00",
    //       isInRange: true,
    //       optimisedValue: "10.00",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   tpdCoverageData: [
    //     {
    //       label: "TPD to Total Monthly Expenses",
    //       desc: "No property selling",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 255.36",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "TPD to Total Monthly Expenses (x Home Mortgage)",
    //       desc: "Only retain home and the rest of properties to be sold",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 255.36",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental TPD to Total Monthly Expenses",
    //       desc: "No property selling",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 255.36",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental TPD to Total Monthly Expenses (x Home Mortgage)",
    //       desc: "Only retain home and the rest of properties to be sold",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 255.36",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   comatoseCoverageData: [
    //     {
    //       label: "Post 30 Days Survival",
    //       desc: "To sustain until 6 months funding to kick in",
    //       range: "6 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Post 6 Months Survival",
    //       desc: "Refer to Total & Permanent Disability Analysis",
    //       range: "-",
    //       value: "8.37",
    //       optimisedValue: "> 255.36",
    //     },
    //   ],
    // },
    // {
    //   name: "Proposal 2",
    //   _id: "2",
    //   naturalDeathCoverageData: [
    //     {
    //       label: "Cover Ratio",
    //       desc: "Based on current age",
    //       range: "27.6 - 31",
    //       value: "0.70",
    //       isInRange: false,
    //       optimisedValue: "21.64",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Death to Total Funding (DTF)",
    //       desc:
    //         "Months of coverage for family after deducting all mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Death to Basic Funding (DBF)",
    //       desc:
    //         "Months of coverage for family after deducting home mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Death to Unsettled Funding (DUF)",
    //       desc:
    //         "Months of coverage for family after deducting immediate death expenses but ignoring all mortgages",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Total Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering all properties mortgage being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Basic Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering home mortgage only being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   accidentalDeathCoverageData: [
    //     {
    //       label: "Accidental Death to Total Funding (DTF)",
    //       desc:
    //         "Months of coverage for family after deducting all mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Death to Basic Funding (DBF)",
    //       desc:
    //         "Months of coverage for family after deducting home mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Death to Unsettled Funding (DUF)",
    //       desc:
    //         "Months of coverage for family after deducting immediate death expenses but ignoring all mortgages",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Total Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering all properties mortgage being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Basic Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering home mortgage only being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   medicalBenefitCoverageData: [
    //     {
    //       label: "Critical Illness (CI) to Monthly Expenses",
    //       desc: "Critical Illness to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "CI-RRF to Monthly Expenses",
    //       desc:
    //         "Critical Illness after reserved for Recovery & Recuperation Funds to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Early CI to Monthly Expenses",
    //       desc: "Critical Illness to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Early CI-RRF to Monthly Expenses",
    //       desc:
    //         "Critical Illness after reserved for Recovery & Recuperation Funds to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Basic CI-IFS",
    //       desc: "Critical Illness Funding Solution Living Expenses Only",
    //       range: "> 100.00%",
    //       value: "0.00%",
    //       isInRange: false,
    //       optimisedValue: "0.00%",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Complete CI-IFS",
    //       desc:
    //         "Critical Illness Funding Solution Living Expenses and Recovery + Recuperation Funds",
    //       range: "> 100.00%",
    //       value: "0.00%",
    //       isInRange: false,
    //       optimisedValue: "0.00%",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Medical Health Insurance (MHI) Funding 0.00",
    //       desc:
    //         "Medical Health Insurance to cover major illness needed to cure",
    //       range: "> 2 times",
    //       value: "10.00",
    //       isInRange: true,
    //       optimisedValue: "10.00",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label:
    //         "Medical Health Insurance (MHI) and Critical Illness (CI) Funding 0.00",
    //       desc:
    //         "Medical Health Insurance and Critical Illness to cover major illness needed to cure",
    //       range: "> 2 times",
    //       value: "10.00",
    //       isInRange: true,
    //       optimisedValue: "10.00",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   tpdCoverageData: [
    //     {
    //       label: "TPD to Total Monthly Expenses",
    //       desc: "No property selling",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 419.69",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "TPD to Total Monthly Expenses (x Home Mortgage)",
    //       desc: "Only retain home and the rest of properties to be sold",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 419.69",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental TPD to Total Monthly Expenses",
    //       desc: "No property selling",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 419.69",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental TPD to Total Monthly Expenses (x Home Mortgage)",
    //       desc: "Only retain home and the rest of properties to be sold",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 419.69",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   comatoseCoverageData: [
    //     {
    //       label: "Post 30 Days Survival",
    //       desc: "To sustain until 6 months funding to kick in",
    //       range: "6 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Post 6 Months Survival",
    //       desc: "Refer to Total & Permanent Disability Analysis",
    //       range: "-",
    //       value: "8.37",
    //       optimisedValue: "> 419.69",
    //     },
    //   ],
    // },
    // {
    //   name: "Proposal 3",
    //   _id: "3",
    //   naturalDeathCoverageData: [
    //     {
    //       label: "Cover Ratio",
    //       desc: "Based on current age",
    //       range: "27.6 - 31",
    //       value: "0.70",
    //       isInRange: false,
    //       optimisedValue: "32.25",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Death to Total Funding (DTF)",
    //       desc:
    //         "Months of coverage for family after deducting all mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Death to Basic Funding (DBF)",
    //       desc:
    //         "Months of coverage for family after deducting home mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Death to Unsettled Funding (DUF)",
    //       desc:
    //         "Months of coverage for family after deducting immediate death expenses but ignoring all mortgages",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Total Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering all properties mortgage being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Basic Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering home mortgage only being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   accidentalDeathCoverageData: [
    //     {
    //       label: "Accidental Death to Total Funding (DTF)",
    //       desc:
    //         "Months of coverage for family after deducting all mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Death to Basic Funding (DBF)",
    //       desc:
    //         "Months of coverage for family after deducting home mortgages and immediate death expenses",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Death to Unsettled Funding (DUF)",
    //       desc:
    //         "Months of coverage for family after deducting immediate death expenses but ignoring all mortgages",
    //       range: "> 0 months",
    //       value: 0,
    //       isInRange: true,
    //       optimisedValue: 0,
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Total Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering all properties mortgage being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental Basic Insurance Funding Solution",
    //       desc:
    //         "Percentage of funding needs considering home mortgage only being solved by using insurance funding",
    //       range: "> 100.00%",
    //       value: "8.62%",
    //       isInRange: false,
    //       optimisedValue: "870.69%",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   medicalBenefitCoverageData: [
    //     {
    //       label: "Critical Illness (CI) to Monthly Expenses",
    //       desc: "Critical Illness to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "CI-RRF to Monthly Expenses",
    //       desc:
    //         "Critical Illness after reserved for Recovery & Recuperation Funds to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Early CI to Monthly Expenses",
    //       desc: "Critical Illness to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Early CI-RRF to Monthly Expenses",
    //       desc:
    //         "Critical Illness after reserved for Recovery & Recuperation Funds to Monthly Expenses",
    //       range: "36 - 60 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Basic CI-IFS",
    //       desc: "Critical Illness Funding Solution Living Expenses Only",
    //       range: "> 100.00%",
    //       value: "0.00%",
    //       isInRange: false,
    //       optimisedValue: "0.00%",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Complete CI-IFS",
    //       desc:
    //         "Critical Illness Funding Solution Living Expenses and Recovery + Recuperation Funds",
    //       range: "> 100.00%",
    //       value: "0.00%",
    //       isInRange: false,
    //       optimisedValue: "0.00%",
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Medical Health Insurance (MHI) Funding 0.00",
    //       desc:
    //         "Medical Health Insurance to cover major illness needed to cure",
    //       range: "> 2 times",
    //       value: "10.00",
    //       isInRange: true,
    //       optimisedValue: "10.00",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label:
    //         "Medical Health Insurance (MHI) and Critical Illness (CI) Funding 0.00",
    //       desc:
    //         "Medical Health Insurance and Critical Illness to cover major illness needed to cure",
    //       range: "> 2 times",
    //       value: "10.00",
    //       isInRange: true,
    //       optimisedValue: "10.00",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   tpdCoverageData: [
    //     {
    //       label: "TPD to Total Monthly Expenses",
    //       desc: "No property selling",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 329.08",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "TPD to Total Monthly Expenses (x Home Mortgage)",
    //       desc: "Only retain home and the rest of properties to be sold",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 329.08",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental TPD to Total Monthly Expenses",
    //       desc: "No property selling",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 329.08",
    //       isOptimisedInRange: true,
    //     },
    //     {
    //       label: "Accidental TPD to Total Monthly Expenses (x Home Mortgage)",
    //       desc: "Only retain home and the rest of properties to be sold",
    //       range: "120 - 240 months",
    //       value: "8.37",
    //       isInRange: false,
    //       optimisedValue: "> 329.08",
    //       isOptimisedInRange: true,
    //     },
    //   ],
    //   comatoseCoverageData: [
    //     {
    //       label: "Post 30 Days Survival",
    //       desc: "To sustain until 6 months funding to kick in",
    //       range: "6 months",
    //       value: 0,
    //       isInRange: false,
    //       optimisedValue: 0,
    //       isOptimisedInRange: false,
    //     },
    //     {
    //       label: "Post 6 Months Survival",
    //       desc: "Refer to Total & Permanent Disability Analysis",
    //       range: "-",
    //       value: "8.37",
    //       optimisedValue: "> 329.08",
    //     },
    //   ],
    // },
  ]);

  const [botName, setBotName] = useState("Lisa (AI Assitant)");
  const [greedingMsg, setGreedingMsg] = useState(`How can I help you?`);
  // const [greedingMsg, setGreedingMsg] = useState(`How can I help you?
  //   \n[Click here to add conversation starter](#conversation-starter)`);
  const [data, setData] = useState([
    {
      type: "system",
      title: botName,
      text: greedingMsg,
      key: "1",
      status: "final",
      // date: new Date(),
    },
    // {
    //   type: "user",
    //   title: botName,
    //   text: `# h1 Heading 8-)
    //     ## h2 Heading
    //     ### h3 Heading
    //     #### h4 Heading
    //     ##### h5 Heading
    //     ###### h6 Heading

    //     ## Horizontal Rules`,
    //   key: "1",
    //   status: "loading",
    //   // date: new Date(),
    // },
  ]);

  const [existingSolution, setExistingSolution] = useState([]);
  ////////////////////////////////////

  useEffect(() => {
    getChatHistory();
  }, [gptSolutionsData]);

  useEffect(() => {
    if (!loading) {
      getSolutionDetails();
    }
  }, [gptSolutionsData, loading]);

  useEffect(() => {
    if (triggerSendMsg) {
      SendMessage();
      setTriggerSendMsg(false);
    }
  }, [triggerSendMsg]);

  const getChatHistory = async () => {
    if (!gptSolutionsData.sessionId) {
      return;
    }

    setLoading(true);
    const res = await getConversationHistory(
      gptSolutionsData.sessionId,
      defaultGptProjectId
    );
    console.log(res, 1081);
    setLoading(false);

    if (res.status === "error") {
      return message.error("Connection error, please try again.");
    }

    if (res.length > 0) {
      setData([
        ...data,
        ...res[0].message.map((x) => {
          return {
            type: x.type === "ai" ? "system" : "user",
            title: botName,
            text: x.data.content,
            key: String(Math.floor(Math.random() * 1000000000 + 1)),
            status: "final",
          };
        }),
      ]);

      // Scroll to bottom
      scrollTop();
    }
  };

  const GetGptSolutions = async (gptId) => {
    setLoading(true);
    const res = await getSolutionsByAdviseeId(adviseeId);
    console.log(res, 1063);
    setExistingSolution(res);
    setLoading(false);
  };

  const getSolutionDetails = async () => {
    console.log(gptSolutionsData._id, 1126);
    if (!gptSolutionsData?._id) {
      return;
    }
    setTabLoading(true);
    const res = await getSolutionById(gptSolutionsData._id);
    console.log(res, 1129);
    setTabLoading(false);

    if (res) {
      // Fix glitch on proposal cards
      setProposalsData([]);
      setTimeout(() => {
        setProposalsData(res.proposalCards);
      }, 100);
    }
  };

  const handleCreateSolution = async (values) => {
    if (connectionError) {
      return message.error("Connection error, please try again.");
    }

    const sessionId = await new Promise((resolve, reject) => {
      messagingSocket.getSessionId((sessionId) => {
        resolve(sessionId);
      });
    });
    console.log(sessionId, 1130);

    setLoading(true);
    const res = await createSolution({
      ...values,
      adviseeId,
      sessionId: sessionId, // For usage of continue conversation
    });
    console.log(res, 1143);

    if (res) {
      message.success("Solution created successfully.");
      setGptSolutionsData(res);
      setSolutionStep(2);
      setInput(res.generatedPrompt);
      setTriggerSendMsg(true);
    }

    setLoading(false);

    return;
  };

  useEffect(() => {
    if (firstLoad) {
      //   getConstantList();
      //   GetProjectDetail();
      GetGptSolutions();

      setTimeout(() => {
        monitorSocketStatus();
        setLoading(false);
        listenIncomingMsg();
        setConnectionError(false);
        setFirstLoad(false);
      }, 1500);
    } else {
    }

    return () => {
      // messagingSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!firstLoad) {
      scrollTop();
    }
  }, [data]);

  const SaveProposals = async (values) => {
    setLoading(true);
    const res = await convertToSolution(gptSolutionsData._id);
    console.log(res, 250);
    if (res.status === "error") {
      setLoading(false);
      return message.error("Connection error, please try again");
    }

    message.success("Proposals saved successfully.");
    history.push(buildPNRProposalsUri(adviseeId));
    // props.setSolutionStep(2);
    //   return;
    // }
  };

  const handleDeleteSolution = async () => {
    setLoading(true);
    const res = await deleteSolution(gptSolutionsData._id);
    console.log(res, 1166);

    message.success("Solution deleted successfully.");

    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  const scrollTop = () => {
    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    }, 100);
  };

  const HandleRegenerate = async (messageId, messageInput) => {
    console.log(messageId, messageInput, 349);
    const input = messageInput;
    const id = messageId;

    setLoading(true);

    const payload = {
      message: input.trim(),
      id: id,
      projectId: defaultGptProjectId,
      clientCredentials: jwtToken,
      ...(gptSolutionsData.sessionId && {
        sessionId: gptSolutionsData.sessionId,
      }),
    };

    messagingSocket.sendMessage(payload, (cb) => {
      // console.log("Send message ack", cb);
      if (cb) {
        // update message status
        setData((prev) => {
          const index = prev.findIndex((x) => x.id === id);
          if (index > -1) {
            prev[index].status = "waiting";
            prev[index].text = "";
            // prev[index].text = inputChat;
          }
          return [...prev];
        });
      }
      setLoading(false);
      setInput("");
    });
  };

  const listenIncomingMsg = () => {
    messagingSocket.listenIncomingMsg((res) => {
      console.log("res", res);
      if (res) {
        const id = res.id;
        const message = res.message;
        const type = res.type;
        const action = res.action;
        // console.log(res, 1273);
        setData((prev) => {
          const index = prev.findIndex((x) => x.id === id);
          // console.log(message, 175);
          // console.log(type, 176);
          if (index > -1) {
            if (type === "final") {
              setLoading(false);
              setTimeout(() => {
                getSolutionDetails();
              }, 1500);
              prev[index].status = "final";
              prev[index].text = message;
              return [...prev];
            }

            switch (message) {
              case "###END###":
                prev[index].status = "received";
                setTimeout(() => {
                  getSolutionDetails();
                }, 1500);
                // prev[index].text = prev[index].text.slice(0, -7);
                break;

              case "###TOOL_START###":
                prev[index].status = "searching";
                prev[index].question = "";
                prev[index].action = action;
                break;

              case "###ERROR###":
                prev[index].status = "error";
                prev[index].text = "Error occured, please try again.";
                prev[index].question = res?.question;
                setLoading(false);
                break;

              default:
                prev[index].status = "received";
                prev[index].text += message;
                break;
            }
          }

          // Fix \n escaping issue
          prev[index].text = prev[index].text?.replace(/\\n/g, `\n`) || "";
          return [...prev];
        });
      }
    });
  };

  const SendMessage = async (regenerateResult) => {
    if (!input) {
      return;
    }

    // return;

    console.log("input", input);

    setLoading(true);
    const id = Math.floor(Math.random() * 1000000000 + 1);
    setData((prev) => [
      ...prev,
      {
        id: String(id),
        // type: "text",
        title: "Me",
        text: input.trim(),
        date: new Date(),
        status: "final",
        type: "user",
      },
      {
        id: String(id + 1),
        type: "system",
        title: "Lisa (AI Assitant)",
        // text: (
        //   <div>
        //     <LoadingOutlined />
        //     {/* <Row>
        //       <Col>
        //         <LikeOutlined />
        //       </Col>
        //       <Col>Not Good</Col>
        //     </Row> */}
        //   </div>
        // ),
        text: "",
        question: "",
        date: new Date(),
        status: "waiting",
      },
    ]);

    const payload = {
      message: input.trim(),
      id: String(id + 1),
      projectId: defaultGptProjectId,
      clientCredentials: jwtToken,
      ...(gptSolutionsData.sessionId && {
        sessionId: gptSolutionsData.sessionId,
      }),
      // when generate proposal it will give solution ID
      // solutionId: gptSolutionsData.solutionId,
    };

    messagingSocket.sendMessage(payload, (cb) => {
      // console.log("Send message ack", cb);
      if (cb) {
        // update message status
        setData((prev) => {
          const index = prev.findIndex((x) => x.id === id);
          if (index > -1) {
            prev[index].status = "received";
            // prev[index].text = inputChat;
          }
          return [...prev];
        });
      }
      // setLoading(false);
      setInput("");
    });
  };

  const monitorSocketStatus = () => {
    socketConnector.connectionStatus((x) => {
      if (x.connected) {
        setConnectionError(false);
        setConnectionSuccessStatus(true);
        setTimeout(() => {
          setConnectionSuccessStatus(false);
        }, 2500);
      } else {
        setOngoingMessageErrorUponDisconnect();
        setLoading(false); // Reset loading state
        setConnectionError(true);
      }
    });
  };

  const setOngoingMessageErrorUponDisconnect = () => {
    setData((prev) => {
      console.log(prev, 214);
      return prev.map((item, index, array) => {
        if (item.status !== "final" && index !== 0) {
          item.status = "error";
          item.text = "Disconnected, please try again.";
          item.question = array[index - 1].text;
        }
        return item;
      });
    });
  };

  const renderReconnectSuccess = connectionSuccessStatus && !connectionError && (
    <Alert
      type="success"
      message={
        <TypeAnimation
          style={{
            width: "100%",
            fontSize: 14,
            color: "rgba(0,0,0,0.65)",
          }}
          sequence={[`Connected`, 500]}
          // repeat={Infinity}
        />
      }
      style={{
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}
      banner
    />
  );

  const renderConnectionError = !firstLoad && connectionError && (
    <Alert
      type="error"
      message={
        <TypeAnimation
          style={{
            width: "100%",
            fontSize: 14,
            color: "rgba(0,0,0,0.65)",
          }}
          sequence={[
            `Reconnecting`,
            500,
            `Reconnecting..`, //  Continuing previous Text
            500,
            `Reconnecting...`,
            500,
          ]}
          repeat={Infinity}
        />
      }
      style={{
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}
      banner
    />
  );

  const renderFirstLoadDialog = firstLoad && connectionError && (
    <Alert
      icon={false}
      message={
        <TypeAnimation
          style={{
            width: "100%",
            fontSize: 14,
            color: "rgba(0,0,0,0.65)",
          }}
          sequence={["", 250, "Connecting to chat server...", 250]}
          repeat={Infinity}
        />
      }
      banner
      type="info"
      style={{
        backgroundColor: "#e6f4ff",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}
    />
  );

  const renderChatBox = useCallback(
    (item, index) => (
      <div
        key={item.id}
        style={{
          backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#fff",
          color: "rgba(0,0,0,.85)",
        }}
      >
        <MemoizedChatBoxComponent
          {...item}
          hideAction={index === 0}
          setInput={setInput}
          projectDetail={props.projectDetail}
          projectId={defaultGptProjectId}
          regenerateInput={regenerateInput}
          setRegenerateInput={setRegenerateInput}
          onSubmit={SendMessage}
          handleRegenerate={HandleRegenerate}
          disabled={loading}
          currentSelected={item}
          previousSelected={data[index - 1]}
          connectionError={connectionError}
        />
      </div>
    ),
    [
      loading,
      setInput,
      SendMessage,
      HandleRegenerate,
      regenerateInput,
      setRegenerateInput,
      connectionError,
    ]
  );

  const GptChat = (
    <div>
      <div
        xs={24}
        md={24}
        xl={18}
        style={{
          borderTop: "1px solid rgba(0,0,0,0.15)",
          borderLeft: "1px solid rgba(0,0,0,0.15)",
          borderRight: "1px solid rgba(0,0,0,0.15)",
          // borderRadius: 8,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          boxShadow: "0px 0px 16spx 0px rgba(0,0,0,0.15)",
        }}
      >
        {renderReconnectSuccess}
        {renderFirstLoadDialog}
        {renderConnectionError}
        <div
          ref={scrollRef}
          style={{
            backgroundColor: "#fff",
            overflowX: "hidden",
            overflowY: "auto",
            height: "60vh",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          {data.map(renderChatBox)}
        </div>
      </div>

      <div
        style={{
          marginTop: 0,
          zIndex: 100,
          borderLeft: "1px solid rgba(0,0,0,0.15)",
          borderRight: "1px solid rgba(0,0,0,0.15)",
          borderBottom: "1px solid rgba(0,0,0,0.15)",
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          backgroundColor: "#fff",
          boxShadow: "0px 0px 16px 0px rgba(0,0,0,0.15)",
        }}
      >
        <PromptForm
          input={input}
          setInput={setInput}
          setRegenerateInput={setRegenerateInput}
          onSubmit={SendMessage}
          disabled={loading || connectionError}
          loading={loading}
          connectionError={connectionError}
        />
      </div>
    </div>
  );

  const IntroductionGptSolutions = (
    <div>
      <Result
        icon={<LogoContainer />}
        title="Finport GPT Assistant"
        subTitle={
          <div style={{ marginTop: 16 }}>
            <Row justify="center">
              <Col style={{ width: 650, textAlign: "left" }}>
                <p>
                  - Finport GPT Assistant is an AI-powered assistant that can
                  help you with your financial planning needs.
                </p>
                <p>
                  - You can ask questions, get advice, and receive proposals
                  from the assistant.
                </p>
                <p>
                  - Click the button below to start a conversation with the
                  assistant.
                </p>
              </Col>
            </Row>
          </div>
        }
        extra={[
          <Button
            size="large"
            key={1}
            type="primary"
            style={{ width: 120 }}
            onClick={() => {
              setSolutionStep(1);
            }}
          >
            Start
          </Button>,
          // Object.keys(gptSolutionsData).length > 0 && (

          // ),
        ]}
      />

      <Row justify="center">
        {existingSolution.length > 0 &&
          existingSolution.map((solution) => (
            <Col
              key={solution._id}
              style={{
                marginLeft: 8,
                marginBottom: 8,
              }}
            >
              <Tooltip title={solution.prompt}>
                <Button
                  size="large"
                  key={2}
                  style={{
                    maxWidth: 300,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => {
                    setSolutionStep(2);
                    setGptSolutionsData(solution);
                  }}
                >
                  Continue - {solution.prompt}
                </Button>
              </Tooltip>
            </Col>
          ))}
      </Row>
    </div>
  );

  const SolutionsStep = (
    <div>
      {solutionStep === 0 ? (
        IntroductionGptSolutions
      ) : solutionStep === 1 ? (
        <SolutionsForm
          setSolutionStep={(e) => setSolutionStep(e)}
          setProposalsData={setProposalsData}
          setRiskRatiosData={setRiskRatiosData}
          setLoading={setLoading}
          createSolution={handleCreateSolution}
        />
      ) : (
        <Tabs
          size="large"
          type="card"
          tabBarExtraContent={
            <>
              <Button
                danger
                style={{
                  marginRight: 8,
                }}
                onClick={async () => {
                  Modal.confirm({
                    title: "Confirm Save Proposals?",
                    onOk: async () => {
                      handleDeleteSolution();
                    },
                  });
                }}
                icon={<DeleteOutlined />}
                disabled={loading}
              >
                Delete
              </Button>
              <Button
                type="primary"
                style={{ marginBottom: 8 }}
                onClick={async () => {
                  Modal.confirm({
                    title: "Confirm Save Proposals?",
                    onOk: async () => {
                      SaveProposals();
                    },
                  });
                }}
              >
                Save Proposals
              </Button>
            </>
          }
        >
          <Tabs.TabPane tab="Proposals" key="1">
            <ProposalsList
              insurancesInfo={props.insurancesInfo}
              currentReporting={props.currentReporting}
              proposalsData={proposalsData}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Risk Ratios" key="2">
            <RiskRatios
              currentReporting={props.currentReporting}
              proposalList={proposalsData}
              // dataRiskRatios={riskRatiosData}
              // riskRatioData={riskRatioData}
              // proposedRiskRatioData={proposedRiskRatioData}
            />
          </Tabs.TabPane>
        </Tabs>
      )}
    </div>
  );

  return (
    <div>
      <Title>GPT Solutions (Alpha Test)</Title>
      <div style={{ position: "relative" }}>
        <Row gutter={24}>
          <Col span={solutionStep === 2 ? 8 : 0}>
            <div style={{ position: "sticky", top: 0 }}>{GptChat}</div>
          </Col>

          <Col span={solutionStep === 2 ? 16 : 24}>
            <Spin tip="Loading" size="large" spinning={tabLoding}>
              {SolutionsStep}
            </Spin>
          </Col>
        </Row>
      </div>
      {/* {ArchieveModal} */}
    </div>
  );
};

export default GptSolutions;
